import { LoadState } from "../../../constants/enums";

export interface IGeneralLedgerState {
  list: IGeneralLedger[];
  loading: LoadState;

  glSummary: IGeneralLedgerSummary[];
  glSummaryLoading: LoadState;
}

export interface IGeneralLedgerSummary {
  gl_account_code: string;
  gl_account_name: string;
  gl_account_type: string;
  year: number;
  january_debit: number;
  january_credit: number;
  january_balance: number;
  february_debit: number;
  february_credit: number;
  february_balance: number;
  march_debit: number;
  march_credit: number;
  march_balance: number;
  april_debit: number;
  april_credit: number;
  april_balance: number;
  may_debit: number;
  may_credit: number;
  may_balance: number;
  june_debit: number;
  june_credit: number;
  june_balance: number;
  july_debit: number;
  july_credit: number;
  july_balance: number;
  August_debit: number;
  August_credit: number;
  August_balance: number;
  september_debit: number;
  september_credit: number;
  september_balance: number;
  november_credit: number;
  november_balance: number;
  december_debit: number;
  december_credit: number;
  december_balance: number;
  total_yearly_balance: number;
  opening_balance: number;
  running_balance: number;
}

export interface IGeneralLedger {
  code: string;
  apr_total: number;
  aug_total: number;
  dec_total: number;
  feb_total: string;
  jan_total: number;
  jul_total: number;
  jun_total: number;
  mar_total: number;
  may_total: number;
  nov_total: number;
  oct_total: number;
}

export const initialGeneralLedgerState: IGeneralLedgerState = {
  list: [],
  loading: LoadState.NotLoaded,
  glSummary: [],
  glSummaryLoading: LoadState.NotLoaded,
};
